<template>

</template>
<script>

    export default {
        props: {
            wikiURL: {
                type: Text,
                required: true,
            }
        },
        created() {
            window.location.href = this.wikiURL;
        }
    }

</script>
